<p>
  {{
    'sharedModule.bkgVehicleDialogCompleteCarDataForm.completeVehicleInfo'
      | translate
  }}
</p>

<form [formGroup]="requestedDataForm">
  <div class="form-group">
    <ng-container *ngIf="bodyControl">
      <label class="text-start">
        {{
          'sharedModule.bkgVehicleDialogCompleteCarDataForm.body' | translate
        }}
      </label>
      <ng-select
        #selectBodyApplicabilitycode
        (change)="selectBodyApplicabilitycode.blur()"
        formControlName="body_applicabilitycode"
        id="body_applicabilitycode"
        [clearable]="false"
        [searchable]="false"
        placeholder="{{
          'sharedModule.bkgVehicleDialogCompleteCarDataForm.selectBody'
            | translate
        }}"
        controlErrorsClass="info-field--warning"
        [appendTo]="'body'"
      >
        <ng-option
          *ngFor="let option of bodyOptions"
          [value]="option.applicabilitycode"
          >{{ option.desc }}</ng-option
        >
      </ng-select>
    </ng-container>

    <ng-container *ngIf="motorControl">
      <label class="text-start">
        {{
          'sharedModule.bkgVehicleDialogCompleteCarDataForm.motor' | translate
        }}
        <div
          *ngIf="loadingMotor"
          class="blue-spinner__small loading__spinner"
        ></div>
      </label>
      <ng-select
        #selectMotoAapplicabilitycode
        (change)="selectMotoAapplicabilitycode.blur()"
        formControlName="motor_applicabilitycode"
        id="motor_applicabilitycode"
        [clearable]="false"
        [searchable]="false"
        placeholder="{{
          'sharedModule.bkgVehicleDialogCompleteCarDataForm.selectMotor'
            | translate
        }}"
        controlErrorsClass="info-field--warning"
        [appendTo]="moreInfoShowing ? null : 'body'"
      >
        <ng-option
          *ngFor="let option of motorOptions"
          [value]="option.applicabilitycode"
          >{{ option.friendlyName }}</ng-option
        >
      </ng-select>
    </ng-container>

    <ng-container *ngIf="kmControl">
      <label class="text-start" style="margin-top: 10px">
        {{
          'sharedModule.bkgVehicleDialogCompleteCarDataForm.kilometers'
            | translate
        }}
      </label>
      <input
        numberDots
        step="1000"
        formControlName="km"
        placeholder="{{
          'sharedModule.bkgVehicleDialogCompleteCarDataForm.kilometers'
            | translate
        }}"
      />
    </ng-container>
  </div>
  <button
    class="btn-primary btn-large is-block"
    [disabled]="requestedDataForm.invalid"
    (click)="submitData()"
  >
    {{ 'sharedModule.bkgVehicleDialogCompleteCarDataForm.agree' | translate }}
  </button>
</form>
